import { render, staticRenderFns } from "./ticket_design.vue?vue&type=template&id=0c4e63fa&scoped=true&"
import script from "./ticket_design.vue?vue&type=script&lang=js&"
export * from "./ticket_design.vue?vue&type=script&lang=js&"
import style0 from "./ticket_design.vue?vue&type=style&index=0&id=0c4e63fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4e63fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContent } from 'vuetify/lib/components/VContent';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VChip,VContent,VDivider})
